import { EntriesTable } from './entries-table';

export default EntriesTable;
